// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ServiceType,
  ModuleType,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  purpose: __t.string(),
  projectId: __t.u32().name("project_id"),
  get consumerModuleType() {
    return ModuleType.name("consumer_module_type");
  },
  targetDatabase: __t.string().name("target_database"),
  identityHex: __t.string().name("identity_hex"),
  provisioned: __t.bool(),
  active: __t.bool(),
  revoked: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
  provisionedAt: __t.option(__t.timestamp()).name("provisioned_at"),
  createdBy: __t.identity().name("created_by"),
  get serviceType() {
    return __t.option(ServiceType).name("service_type");
  },
  registeredServiceId: __t.option(__t.u32()).name("registered_service_id"),
  expiresAt: __t.option(__t.timestamp()).name("expires_at"),
});
